import { useState } from 'react';

export default function useLoadMoreCounter(defaultVisibleItemsCount, maxItems) {
  const [visibleItemsCount, setVisibleItemsCount] = useState(defaultVisibleItemsCount);

  const showMoreItems = () => {
    const addItemsCount = Math.min(defaultVisibleItemsCount, maxItems - visibleItemsCount);
    setVisibleItemsCount((value) => value + addItemsCount);
  };

  return [visibleItemsCount, showMoreItems];
}
